import { ReactNode } from 'react'

import styles from './ControlsRow.scss'


type Props = {
  children: ReactNode
}

export const ControlsRow = ({ children }: Props) => {
  return (
    <div className={styles.root}>{children}</div>
  )
}
